"use client";
import { Get } from "@/axios/AxiosFunctions";
import { Button } from "@/components/Core/Button";
import NoData from "@/components/Core/NoData/NoData";
import SearchInput from "@/components/Core/SearchInput";
import Skeleton from "@/components/Skeleton";
import { BaseURL, imageUrl } from "@/config/apiUrl";
// import { RECORDS_LIMIT } from "@/constant/constants";
import useDebounce from "@/customHooks/useDebounce";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./FollowerModal.module.css";
import { RECORDS_LIMIT } from "@/constant/constants";

const LOADING_STATES = {
  GET_FOLLOWERS: "get_followers",
  SHOW_MORE_LOADER: "show_more_loader",
};

export default function UsersModal({
  show,
  setShow,
  url = "user-relations/find/followers",
  header = "Followers",
}) {
  const { access_token } = useSelector((state) => state?.authReducer);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(null);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  // fetch followers
  const fetchData = async (
    pgNo = page,
    prev = [],
    loadingType = LOADING_STATES.GET_FOLLOWERS
  ) => {
    const queryParams = {
      page: pgNo,
      limit: RECORDS_LIMIT,
      search: debouncedSearch,
    };
    const apiUrl = BaseURL(
      `${url}?${new URLSearchParams(queryParams).toString()}`
    );

    setLoading(loadingType);
    const response = await Get(apiUrl, access_token);
    if (response !== undefined) {
      const { users = [], totalCount = 0 } = response?.data || {};
      setData([...prev, ...users]);
      setTotalCount(totalCount);
    }
    setLoading(null);
  };

  useEffect(() => {
    setPage(1);
    fetchData(1);
  }, [debouncedSearch]);

  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      overflowModalBody="visible"
      width="550px"
      modalClass={classes.modalContent}
      header={header}
    >
      <div className={classes.followerContainer}>
        <SearchInput
          value={search}
          setter={setSearch}
          placeholder={`Search ${header}`}
          customStyle={{
            width: "100%",
          }}
          inputStyle={{
            border: "var(--input-border)",
            borderRadius: "10px",
            paddingBlock: "10px",
          }}
        />
        <div className={classes.followersList}>
          {loading === LOADING_STATES.GET_FOLLOWERS ? (
            Array.from({ length: 3 }).map((_, index) => (
              <Skeleton
                key={index}
                height={60}
                width="100%"
                className={classes.skeletonBox}
              />
            ))
          ) : data?.length > 0 ? (
            data?.map((item, index) => (
              <FollowerCard
                key={item?._id || index}
                item={{
                  ...item,
                  user: item,
                }}
              />
            ))
          ) : (
            <NoData text={`No ${header} found`} />
          )}
        </div>
        {page < Math.ceil(totalCount / RECORDS_LIMIT) && (
          <div className={classes.showMorePosts}>
            {loading == LOADING_STATES.SHOW_MORE_LOADER ? (
              <Spinner animation="border" />
            ) : (
              <Button
                className={classes.showMoreButton}
                onClick={() => {
                  setPage((pre) => pre + 1);
                  fetchData(page + 1, data, LOADING_STATES.SHOW_MORE_LOADER);
                }}
                label={"Show More"}
              />
            )}
          </div>
        )}
      </div>
    </ModalSkeleton>
  );
}

const FollowerCard = ({ item }) => {
  const navigate = useNavigate();
  return (
    <div className={classes.followerCard}>
      <div className={classes.followerCardHeaderWrapper}>
        <div className={classes.followerCardHeader}>
          <div className={classes.followerCardHeaderLeft}>
            <div className={classes.profileIcon}>
              <img
                src={imageUrl(item?.user?.image)}
                alt={item?.user?.fullName}
                width={40}
                height={40}
                className={classes.profileImage}
              />
            </div>
          </div>
          <div className={classes.followerCardHeaderRight}>
            <p
              onClick={() => {
                navigate(`/users/${item?.user?._id}`);
              }}
            >
              {item?.user?.fullName}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
